/**
 * Created by Pan on 16/5/31.
 * header 和 footer
 */
import 'bootsets/compatibility/base'
import setsFooter from './sets-footer.vue'
import setsHeader from './sets-header.vue'

const Scaffold = {
    setsFooter, setsHeader
}
module.exports = Scaffold


// WEBPACK FOOTER //
// ./app/scaffold/index.js